var _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineHeaderRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 1,
    viewBox: "0 0 53 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.5,
    x2: 52.5,
    y2: 0.499995,
    stroke: "url(#paint0_linear_4950_35212)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4950_35212",
    x1: 53,
    y1: 0.999995,
    x2: 0,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#B779F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B779F8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeaderRight);
export default __webpack_public_path__ + "static/media/line-header-right.684bf1d1d06f2e04219edd95f20e39e5.svg";
export { ForwardRef as ReactComponent };